import HNav from "../home/H_Nav";
import "../style/contact-us/ContactUs.scss";
import Info from "./Info";
import Map from './Map';
import SendMessage from "./SendMessage";

const ContactUs = () => {
  return (
    <div className="ContactUs">
      <HNav />
      <div className="ContactUs-container">
        <div className="ContactUs-container-title">تماس با ما</div>
        <div className="ContactUs-container-right-part">
          <SendMessage />
        </div>
        <div className="ContactUs-container-left-part">
          <Info />
          {/* <Map/> */}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
